module.exports = function (t) {
  var e = {};

  function r(n) {
    if (e[n]) return e[n].exports;
    var o = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = t, r.c = e, r.d = function (t, e, n) {
    r.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      r.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 17);
}([function (t, e) {
  function r(t) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function n(e) {
    return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = n = function n(t) {
      return r(t);
    } : t.exports = n = function n(t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t);
    }, n(e);
  }

  t.exports = n;
}, function (t, e, r) {
  t.exports = r(11);
}, function (t, e) {
  t.exports = function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  };
}, function (t, e) {
  t.exports = function (t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = r, t;
  };
}, function (t, e) {
  t.exports = require("react");
}, function (t, e) {
  t.exports = function (t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  };
}, function (t, e) {
  function r(t, e) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }

  t.exports = function (t, e, n) {
    return e && r(t.prototype, e), n && r(t, n), t;
  };
}, function (t, e) {
  function r(t, e, r, n, o, i, a) {
    try {
      var c = t[i](a),
          s = c.value;
    } catch (t) {
      return void r(t);
    }

    c.done ? e(s) : Promise.resolve(s).then(n, o);
  }

  t.exports = function (t) {
    return function () {
      var e = this,
          n = arguments;
      return new Promise(function (o, i) {
        var a = t.apply(e, n);

        function c(t) {
          r(a, o, i, c, s, "next", t);
        }

        function s(t) {
          r(a, o, i, c, s, "throw", t);
        }

        c(void 0);
      });
    };
  };
}, function (t, e, r) {
  var n = r(0),
      o = r(2);

  t.exports = function (t, e) {
    return !e || "object" !== n(e) && "function" != typeof e ? o(t) : e;
  };
}, function (t, e) {
  function r(e) {
    return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, r(e);
  }

  t.exports = r;
}, function (t, e, r) {
  var n = r(12);

  t.exports = function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && n(t, e);
  };
}, function (t, e, r) {
  var n = function (t) {
    "use strict";

    var e,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";

    function s(t, e, r, n) {
      var o = e && e.prototype instanceof d ? e : d,
          i = Object.create(o.prototype),
          a = new T(n || []);
      return i._invoke = function (t, e, r) {
        var n = l;
        return function (o, i) {
          if (n === f) throw new Error("Generator is already running");

          if (n === h) {
            if ("throw" === o) throw i;
            return P();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var c = E(a, r);

              if (c) {
                if (c === y) continue;
                return c;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === l) throw n = h, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = f;
            var s = u(t, e, r);

            if ("normal" === s.type) {
              if (n = r.done ? h : p, s.arg === y) continue;
              return {
                value: s.arg,
                done: r.done
              };
            }

            "throw" === s.type && (n = h, r.method = "throw", r.arg = s.arg);
          }
        };
      }(t, r, a), i;
    }

    function u(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = s;
    var l = "suspendedStart",
        p = "suspendedYield",
        f = "executing",
        h = "completed",
        y = {};

    function d() {}

    function m() {}

    function v() {}

    var b = {};

    b[i] = function () {
      return this;
    };

    var g = Object.getPrototypeOf,
        x = g && g(g(L([])));
    x && x !== r && n.call(x, i) && (b = x);
    var w = v.prototype = d.prototype = Object.create(b);

    function S(t) {
      ["next", "throw", "return"].forEach(function (e) {
        t[e] = function (t) {
          return this._invoke(e, t);
        };
      });
    }

    function O(t) {
      var e;

      this._invoke = function (r, o) {
        function i() {
          return new Promise(function (e, i) {
            !function e(r, o, i, a) {
              var c = u(t[r], t, o);

              if ("throw" !== c.type) {
                var s = c.arg,
                    l = s.value;
                return l && "object" == typeof l && n.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                  e("next", t, i, a);
                }, function (t) {
                  e("throw", t, i, a);
                }) : Promise.resolve(l).then(function (t) {
                  s.value = t, i(s);
                }, function (t) {
                  return e("throw", t, i, a);
                });
              }

              a(c.arg);
            }(r, o, e, i);
          });
        }

        return e = e ? e.then(i, i) : i();
      };
    }

    function E(t, r) {
      var n = t.iterator[r.method];

      if (n === e) {
        if (r.delegate = null, "throw" === r.method) {
          if (t.iterator.return && (r.method = "return", r.arg = e, E(t, r), "throw" === r.method)) return y;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return y;
      }

      var o = u(n, t.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
      var i = o.arg;
      return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, y) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }

    function j(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function k(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function T(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(j, this), this.reset(!0);
    }

    function L(t) {
      if (t) {
        var r = t[i];
        if (r) return r.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var o = -1,
              a = function r() {
            for (; ++o < t.length;) {
              if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
            }

            return r.value = e, r.done = !0, r;
          };

          return a.next = a;
        }
      }

      return {
        next: P
      };
    }

    function P() {
      return {
        value: e,
        done: !0
      };
    }

    return m.prototype = w.constructor = v, v.constructor = m, v[c] = m.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, c in t || (t[c] = "GeneratorFunction")), t.prototype = Object.create(w), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, S(O.prototype), O.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = O, t.async = function (e, r, n, o) {
      var i = new O(s(e, r, n, o));
      return t.isGeneratorFunction(r) ? i : i.next().then(function (t) {
        return t.done ? t.value : i.next();
      });
    }, S(w), w[c] = "Generator", w[i] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e.reverse(), function r() {
        for (; e.length;) {
          var n = e.pop();
          if (n in t) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, t.values = L, T.prototype = {
      constructor: T,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(k), !t) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var r = this;

        function o(n, o) {
          return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              c = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var s = n.call(a, "catchLoc"),
                u = n.call(a, "finallyLoc");

            if (s && u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (s) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), k(r), y;
        }
      },
      catch: function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];

          if (r.tryLoc === t) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;
              k(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, r, n) {
        return this.delegate = {
          iterator: L(t),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = e), y;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = n;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(n);
  }
}, function (t, e) {
  function r(e, n) {
    return t.exports = r = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    }, r(e, n);
  }

  t.exports = r;
}, function (t, e, r) {
  var n = r(14);
  "string" == typeof n && (n = [[t.i, n, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  r(16)(n, o);
  n.locals && (t.exports = n.locals);
}, function (t, e, r) {
  (t.exports = r(15)(!1)).push([t.i, ".react-typewriter-text {\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.react-typewriter-pointer {\n  background-color: black;\n  display: inline;\n  padding: 0 1px;\n}\n\n.add-cursor-animate {\n    animation: blink 1s step-end infinite;\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.hide-typing-cursor {\n    padding: 0;\n}", ""]);
}, function (t, e, r) {
  "use strict";

  t.exports = function (t) {
    var e = [];
    return e.toString = function () {
      return this.map(function (e) {
        var r = function (t, e) {
          var r = t[1] || "",
              n = t[3];
          if (!n) return r;

          if (e && "function" == typeof btoa) {
            var o = (a = n, c = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(c), "/*# ".concat(s, " */")),
                i = n.sources.map(function (t) {
              return "/*# sourceURL=".concat(n.sourceRoot).concat(t, " */");
            });
            return [r].concat(i).concat([o]).join("\n");
          }

          var a, c, s;
          return [r].join("\n");
        }(e, t);

        return e[2] ? "@media ".concat(e[2], "{").concat(r, "}") : r;
      }).join("");
    }, e.i = function (t, r) {
      "string" == typeof t && (t = [[null, t, ""]]);

      for (var n = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        null != i && (n[i] = !0);
      }

      for (var a = 0; a < t.length; a++) {
        var c = t[a];
        null != c[0] && n[c[0]] || (r && !c[2] ? c[2] = r : r && (c[2] = "(".concat(c[2], ") and (").concat(r, ")")), e.push(c));
      }
    }, e;
  };
}, function (t, e, r) {
  "use strict";

  var n,
      o = {},
      i = function i() {
    return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
  },
      a = function () {
    var t = {};
    return function (e) {
      if (void 0 === t[e]) {
        var r = document.querySelector(e);
        if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
          r = r.contentDocument.head;
        } catch (t) {
          r = null;
        }
        t[e] = r;
      }

      return t[e];
    };
  }();

  function c(t, e) {
    for (var r = [], n = {}, o = 0; o < t.length; o++) {
      var i = t[o],
          a = e.base ? i[0] + e.base : i[0],
          c = {
        css: i[1],
        media: i[2],
        sourceMap: i[3]
      };
      n[a] ? n[a].parts.push(c) : r.push(n[a] = {
        id: a,
        parts: [c]
      });
    }

    return r;
  }

  function s(t, e) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r],
          i = o[n.id],
          a = 0;

      if (i) {
        for (i.refs++; a < i.parts.length; a++) {
          i.parts[a](n.parts[a]);
        }

        for (; a < n.parts.length; a++) {
          i.parts.push(m(n.parts[a], e));
        }
      } else {
        for (var c = []; a < n.parts.length; a++) {
          c.push(m(n.parts[a], e));
        }

        o[n.id] = {
          id: n.id,
          refs: 1,
          parts: c
        };
      }
    }
  }

  function u(t) {
    var e = document.createElement("style");

    if (void 0 === t.attributes.nonce) {
      var n = r.nc;
      n && (t.attributes.nonce = n);
    }

    if (Object.keys(t.attributes).forEach(function (r) {
      e.setAttribute(r, t.attributes[r]);
    }), "function" == typeof t.insert) t.insert(e);else {
      var o = a(t.insert || "head");
      if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      o.appendChild(e);
    }
    return e;
  }

  var l,
      p = (l = [], function (t, e) {
    return l[t] = e, l.filter(Boolean).join("\n");
  });

  function f(t, e, r, n) {
    var o = r ? "" : n.css;
    if (t.styleSheet) t.styleSheet.cssText = p(e, o);else {
      var i = document.createTextNode(o),
          a = t.childNodes;
      a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
    }
  }

  function h(t, e, r) {
    var n = r.css,
        o = r.media,
        i = r.sourceMap;
    if (o && t.setAttribute("media", o), i && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleSheet) t.styleSheet.cssText = n;else {
      for (; t.firstChild;) {
        t.removeChild(t.firstChild);
      }

      t.appendChild(document.createTextNode(n));
    }
  }

  var y = null,
      d = 0;

  function m(t, e) {
    var r, n, o;

    if (e.singleton) {
      var i = d++;
      r = y || (y = u(e)), n = f.bind(null, r, i, !1), o = f.bind(null, r, i, !0);
    } else r = u(e), n = h.bind(null, r, e), o = function o() {
      !function (t) {
        if (null === t.parentNode) return !1;
        t.parentNode.removeChild(t);
      }(r);
    };

    return n(t), function (e) {
      if (e) {
        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
        n(t = e);
      } else o();
    };
  }

  t.exports = function (t, e) {
    (e = e || {}).attributes = "object" == typeof e.attributes ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i());
    var r = c(t, e);
    return s(r, e), function (t) {
      for (var n = [], i = 0; i < r.length; i++) {
        var a = r[i],
            u = o[a.id];
        u && (u.refs--, n.push(u));
      }

      t && s(c(t, e), e);

      for (var l = 0; l < n.length; l++) {
        var p = n[l];

        if (0 === p.refs) {
          for (var f = 0; f < p.parts.length; f++) {
            p.parts[f]();
          }

          delete o[p.id];
        }
      }
    };
  };
}, function (t, e, r) {
  "use strict";

  r.r(e);

  var n = r(0),
      o = r.n(n),
      i = r(1),
      a = r.n(i),
      c = r(7),
      s = r.n(c),
      u = r(5),
      l = r.n(u),
      p = r(6),
      f = r.n(p),
      h = r(8),
      y = r.n(h),
      d = r(9),
      m = r.n(d),
      v = r(2),
      b = r.n(v),
      g = r(10),
      x = r.n(g),
      w = r(3),
      S = r.n(w),
      O = r(4),
      E = r.n(O),
      j = function () {
    function t(e) {
      l()(this, t), this.time = e, this.timeout = null, this.close = null;
    }

    return f()(t, [{
      key: "getPromise",
      value: function value() {
        var t = this;
        return new Promise(function (e, r) {
          t.close = r, t.timeout = setTimeout(function () {
            e();
          }, t.time);
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        return this.timeout && clearTimeout(this.timeout), this.close && this.close("unmounted"), {
          isCanceled: !0
        };
      }
    }]), t;
  }(),
      k = {
    multiTextDelay: function multiTextDelay(t, e) {
      return t[e] && "number" != typeof t[e] ? new Error("Invalid ".concat(e, " supplied to react-type-writer-component component.")) : !t.multiText && t[e] ? new Error("Invalid!. multiText props must be provided to use ".concat(e, " .")) : void 0;
    },
    typeSpeed: function typeSpeed(t, e) {
      if (t[e] && "number" != typeof t[e]) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component."));
    },
    startDelay: function startDelay(t, e) {
      if (t[e] && "number" != typeof t[e]) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component."));
    },
    text: function text(t, e) {
      if (!t.multiText && "string" != typeof t[e]) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component!"));
    },
    cursorColor: function cursorColor(t, e) {
      if (t[e] && "string" != typeof t[e]) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component!"));
    },
    textStyle: function textStyle(t, e) {
      if (t[e] && "object" != o()(t[e])) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component!"));
    },
    multiText: function multiText(t, e) {
      if (t[e] && "object" == o()(t[e])) {
        for (var r = 0; r < t[e].length; r++) {
          if ("string" != typeof t[e][r]) return new Error("Invalid element: ".concat(t[e][r], " for ").concat(e, " supplied to react-typeWriter component!"));
        }
      } else if (t[e] && "object" !== o()(t[e])) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component!"));
    },
    scrollArea: function scrollArea(t, e) {
      if (t[e] && "object" != o()(t[e])) return new Error("Invalid ".concat(e, " supplied to typewriter component!"));
    },
    multiTextLoop: function multiTextLoop(t, e) {
      if (t[e] && "boolean" != typeof t[e]) return new Error("Invalid ".concat(e, " supplied to react-typeWriter component."));
    }
  },
      T = function T(t) {
    var e = window.scrollY || window.pageYOffset,
        r = t.getBoundingClientRect(),
        n = r.top + e,
        o = e,
        i = e + window.innerHeight,
        a = n,
        c = n + r.height;
    return c >= o && c <= i || a <= i && a >= o;
  };

  r(13);

  function L(t, e) {
    var r = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function P(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? L(r, !0).forEach(function (e) {
        S()(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : L(r).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }

    return t;
  }

  var D = function (t) {
    function e() {
      var t, r;
      l()(this, e);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return r = y()(this, (t = m()(e)).call.apply(t, [this].concat(o))), S()(b()(r), "state", {
        text: "",
        blink: !1,
        hideCursor: !0,
        animate: !1,
        typeSpeedDelay: null,
        multiTextDelay: null,
        eraseSpeedDelay: null,
        startDelay: null,
        scrollAreaIsSet: null,
        multiTextLoop: !1
      }), S()(b()(r), "myRef", Object(O.createRef)()), S()(b()(r), "multiTextDisplay", function () {
        var t = s()(a.a.mark(function t(e) {
          var n;
          return a.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = 0;

                case 1:
                  if (!(n < e.length)) {
                    t.next = 7;
                    break;
                  }

                  return t.next = 4, r.runAnimation(e[n], e.length - n - 1);

                case 4:
                  n++, t.next = 1;
                  break;

                case 7:
                  if (!r.props.multiTextLoop) {
                    t.next = 11;
                    break;
                  }

                  return t.next = 10, r.eraseText(e[e.length - 1]);

                case 10:
                  r.multiTextDisplay(e);

                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }()), S()(b()(r), "runAnimation", function () {
        var t = s()(a.a.mark(function t(e, n) {
          var o, i, c, s, u;
          return a.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (!(o = "string" == typeof e && e.trim().split(""))) {
                    t.next = 25;
                    break;
                  }

                  r.setState({
                    blink: !1
                  }), i = "", c = new j(r.props.typeSpeed || 120), s = r.props.multiText && new j(r.props.multiTextDelay || 2e3), r.setState({
                    typeSpeedDelay: c,
                    multiTextDelay: s
                  }), u = 0;

                case 8:
                  if (!(u < o.length)) {
                    t.next = 16;
                    break;
                  }

                  return t.next = 11, c.getPromise();

                case 11:
                  i += o[u], r.setState({
                    text: i
                  });

                case 13:
                  u++, t.next = 8;
                  break;

                case 16:
                  if (r.setState({
                    blink: !0
                  }), t.t0 = r.props.multiText, !t.t0) {
                    t.next = 21;
                    break;
                  }

                  return t.next = 21, s.getPromise();

                case 21:
                  if (t.t1 = n > 0, !t.t1) {
                    t.next = 25;
                    break;
                  }

                  return t.next = 25, r.eraseText(i);

                case 25:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e, r) {
          return t.apply(this, arguments);
        };
      }()), S()(b()(r), "eraseText", function () {
        var t = s()(a.a.mark(function t(e) {
          var n, o, i, c;
          return a.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = "string" == typeof e && e.trim().split(""), r.setState({
                    blink: !1
                  }), o = e.trim(), i = new j(50), r.setState({
                    eraseSpeedDelay: i
                  }), c = 0;

                case 6:
                  if (!(c < n.length)) {
                    t.next = 14;
                    break;
                  }

                  return t.next = 9, i.getPromise();

                case 9:
                  o = o.slice(0, -1), r.setState({
                    text: o
                  });

                case 11:
                  c++, t.next = 6;
                  break;

                case 14:
                  r.setState({
                    blink: !0
                  });

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }()), S()(b()(r), "animateOnScroll", s()(a.a.mark(function t() {
        var e;
        return a.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (t.prev = 0, r.state.animate || !T(r.myRef.current)) {
                  t.next = 17;
                  break;
                }

                if (r.setState({
                  animate: !0
                }), e = r.props.startDelay && new j(r.props.startDelay), r.setState({
                  hideCursor: !1,
                  startDelay: e
                }), t.t0 = r.props.startDelay, !t.t0) {
                  t.next = 9;
                  break;
                }

                return t.next = 9, e.getPromise();

              case 9:
                if (!r.props.multiText) {
                  t.next = 14;
                  break;
                }

                return t.next = 12, r.multiTextDisplay(r.props.multiText);

              case 12:
                t.next = 16;
                break;

              case 14:
                return t.next = 16, r.runAnimation(r.props.text);

              case 16:
                r.props.hideCursorAfterText && r.setState({
                  hideCursor: !0
                });

              case 17:
                t.next = 21;
                break;

              case 19:
                t.prev = 19, t.t1 = t.catch(0);

              case 21:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[0, 19]]);
      }))), r;
    }

    return x()(e, t), f()(e, [{
      key: "componentDidMount",
      value: function value() {
        this.animateOnScroll(), this.setState({
          scrollAreaIsSet: !1
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.state.scrollAreaIsSet || (this.setState({
          scrollAreaIsSet: !0
        }), this.props.scrollArea && "object" == o()(this.props.scrollArea) ? this.props.scrollArea.addEventListener("scroll", this.animateOnScroll) : document.addEventListener("scroll", this.animateOnScroll));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.scrollArea && "object" == o()(this.props.scrollArea) ? this.props.scrollArea.removeEventListener("scroll", this.animateOnScroll) : document.removeEventListener("scroll", this.animateOnScroll), this.state.startDelay && this.state.startDelay.cancel(), this.state.eraseSpeedDelay && this.state.eraseSpeedDelay.cancel(), this.state.typeSpeedDelay && this.state.typeSpeedDelay.cancel(), this.state.multiTextDelay && this.state.multiTextDelay.cancel();
      }
    }, {
      key: "render",
      value: function value() {
        return E.a.createElement("div", {
          ref: this.myRef,
          className: "react-typewriter-text-wrap"
        }, E.a.createElement("h1", {
          style: P({}, this.props.textStyle),
          className: "react-typewriter-text"
        }, this.state.text, E.a.createElement("div", {
          className: "react-typewriter-pointer ".concat(this.state.blink && "add-cursor-animate", " ").concat(this.state.hideCursor ? "hide-typing-cursor" : ""),
          style: {
            backgroundColor: "".concat(this.props.cursorColor)
          }
        })));
      }
    }]), e;
  }(O.Component);

  D.propTypes = k;
  e.default = D;
}]);